// Open the desktop header dropdown menu on mouse hover, reusing Dawn's existing
// click/[open]-attribute behavior (and its animations) instead of fighting it with CSS.
document.addEventListener('DOMContentLoaded', function () {
  if (!window.matchMedia('(min-width: 990px)').matches) return;

  document.querySelectorAll('.header__inline-menu details').forEach(function (details) {
    var closeTimer;

    details.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      if (!details.hasAttribute('open')) details.setAttribute('open', '');
    });

    details.addEventListener('mouseleave', function () {
      closeTimer = setTimeout(function () {
        details.removeAttribute('open');
      }, 150);
    });
  });
});
